import { PermissionsResourceType } from './PermissionsResourceType.js';
/**
 * PermissionLevels are used to grant permissions to specific resources or system wide
 */
export var PermissionLevel;
(function (PermissionLevel) {
    /** No access */
    PermissionLevel["None"] = "None";
    /** Read all data, but not allowed to write */
    PermissionLevel["Read"] = "Read";
    /** Read, write, add, delete child data, but not allowed to modify settings */
    PermissionLevel["Write"] = "Write";
    /** Full access */
    PermissionLevel["Full"] = "Full";
})(PermissionLevel || (PermissionLevel = {}));
export function getPermissionLevelNumber(level) {
    switch (level) {
        case PermissionLevel.None: return 0;
        case PermissionLevel.Read: return 1;
        case PermissionLevel.Write: return 2;
        case PermissionLevel.Full: return 3;
        default: {
            const l = level; // will throw compile error if new levels are added without editing this method
            throw new Error('Unknown permission level ' + l);
        }
    }
}
export function maximumPermissionlevel(...levels) {
    let max = PermissionLevel.None;
    for (const level of levels) {
        if (getPermissionLevelNumber(level) > getPermissionLevelNumber(max)) {
            max = level;
        }
    }
    return max;
}
export function minimumPermissionLevel(...levels) {
    let min = levels[0];
    for (const level of levels) {
        if (getPermissionLevelNumber(level) < getPermissionLevelNumber(min)) {
            min = level;
        }
    }
    return min;
}
export function getPermissionLevelName(level, resourceType = null) {
    if (resourceType === PermissionsResourceType.Senders) {
        switch (level) {
            case PermissionLevel.Read: return $t(`1b2bf97a-f263-40f6-9246-4f0cb326f5ff`);
            case PermissionLevel.Write: return $t(`c77d1dfb-a556-4373-9643-5ebe22dc7c21`);
        }
    }
    switch (level) {
        case PermissionLevel.None: return $t(`e7aebbf1-8a3a-4288-932f-1678c7bb16ca`);
        case PermissionLevel.Read: return $t(`7afc105f-d34d-4b93-9b33-a6cc08c818ee`);
        case PermissionLevel.Write: return $t(`ad3ad207-6470-4f3e-aaf4-1ea5ea8b85ad`);
        case PermissionLevel.Full: return $t(`c2296305-99a9-497a-aed3-7bb3d2293ce8`);
        default: {
            const l = level; // will throw compile error if new levels are added without editing this method
            throw new Error('Unknown permission level ' + l);
        }
    }
}
//# sourceMappingURL=PermissionLevel.js.map